const React = require('react');
const LayoutA = require('../../../dumb/Layout/A');
const CaptionA = require('../../../dumb/Caption/A');
const HeaderA = require('../../../dumb/Header/A');
const ReportDownload = require('../../../dumb/ReportDownload');
const Switch = require('../../../dumb/Switch/D');
const withState = require('../../../../utils/withState');
const KeyboardDatePickerB = require("../../../dumb/KeyboardDatePicker/B");
const formatDate = require("mn-utils/formatDate");
const delay = require("mn-utils/delay");
const WrapperWithLoading = require('../../../dumb/WrapperWithLoading');
const ButtonBlack = require("../../../dumb/Button/Black");



module.exports = withState((setState, self) => {
  const dateTo = new Date();
  const dateFrom = new Date();
  const dateCurrent = new Date();
  dateFrom.setDate(dateTo.getDate() - 30);
  self.state = {
    ...(self.state || {}),
    dateTo,
    dateFrom,
    dateCurrent,
    isCurrentMonth: true
  };

  function handleChangeDateTo(dateTo) {
    setState({
      dateTo,
    });
  }
  function handleChangeDateFrom(dateFrom) {
    setState({
      dateFrom,
    });
  }

  function dateToMonth(rawDate) {
    const date = new Date(rawDate);
    const month = date.getMonth();
    const year = date.getFullYear();

    return {month, year};
  }

  function dateToGMT(rawDate) {
    const date = new Date(rawDate);
    return (date.getTime() + (date.getTimezoneOffset()*60*1000 * -1));
  }

  function getMonthStart(rawDate) {
    const {month, year} = dateToMonth(rawDate);
    return dateToGMT(new Date(year, month, 1));
  }

  function getMonthEnd(rawDate) {
    const {month, year} = dateToMonth(rawDate);
    const lastDayOfMonth = new Date(year, month + 1, 1).getTime() - 86400000;
    return dateToGMT(lastDayOfMonth);
  }

  return (state) => {
    const {isCurrentMonth, dateCurrent, dateTo, dateFrom} = state;
    const toggleMonth = () => setState({isCurrentMonth: !isCurrentMonth});

    const firstDayOfMonth = getMonthStart(isCurrentMonth ? dateCurrent : dateFrom);
    const lastDayOfMonth = getMonthEnd(isCurrentMonth ? dateCurrent : dateTo);
    const currentDate = getMonthEnd(new Date().getTime());

    const disableBtns = !firstDayOfMonth
      || firstDayOfMonth < 0
      || isNaN(firstDayOfMonth)
      || firstDayOfMonth > currentDate
      || !lastDayOfMonth
      || lastDayOfMonth < 0
      || isNaN(lastDayOfMonth)
      || lastDayOfMonth > currentDate
      || firstDayOfMonth > lastDayOfMonth;

    function getLink(key) {
      return '/v2/admin/balance-accounting-report/' + key + '?from='
        + Math.floor(firstDayOfMonth * 0.001)
        + '&to=' + Math.floor(lastDayOfMonth * 0.001);
    }
    function getName(key) {
      return 'transactions_'
        + formatDate(firstDayOfMonth, 'yyyy-mm-dd') + '_'
        + formatDate(lastDayOfMonth, 'yyyy-mm-dd') + '.' + key;
    }
    function handleLoading() {
      setState({
        loading: true,
      });
      delay(setState, 2000, [{loading: false}]);
    }

    return (
      <LayoutA className="wmin1030*2">
        <HeaderA>
          <CaptionA>Statements</CaptionA>
        </HeaderA>
        <div className="layoutRow aiC (crP):h" onClick={toggleMonth}>
          <span
            className={`dB mr15 f12 fw7 lh18 o70 o100:h (o100|o70:h).active` + (!isCurrentMonth ? ' active' : '')}
          >Custom Period</span>
          <Switch
            className={
              `(bcF)>.SwitchC_Btn (bcF)>.SwitchC_Btn:not[.disabled]:h 
              (bgF)>.SwitchC_Circle.checked 
              (bgF-i)>.SwitchC_Btn:not[.disabled]:h>.SwitchC_Circle.checked`
            }
            // label="Current Month"
            checked={isCurrentMonth}
            onClick={toggleMonth}
          />
          <span
            className={`dB ml15 f12 fw7 lh18 o70 o100:h (o100|o70:h).active` + (isCurrentMonth ? ' active' : '')}
          >Current Month</span>
        </div>
        <WrapperWithLoading loading={state.loading}>
          <div className="layoutRow">
            {isCurrentMonth
              ? (
                <div className="w(|min)510 mr10">
                  <KeyboardDatePickerB
                    format="MM.yyyy"
                    className="mt20"
                    disableFuture
                    label="Current month"
                    value={dateCurrent}
                    views={['year', 'month']}
                    disabled
                  />
                </div>
              ) : (
                <>
                  <div className="item w(|min)250 mr10">
                    <KeyboardDatePickerB
                      format="MM.yyyy"
                      className="mt20"
                      disableFuture
                      label="Month from"
                      value={dateFrom}
                      maxDate={lastDayOfMonth}
                      views={['year', 'month']}
                      onChange={handleChangeDateFrom}
                    />
                  </div>
                  <div className="item w(|min)250 mr10">
                    <KeyboardDatePickerB
                      format="MM.yyyy"
                      className="mt20"
                      disableFuture
                      minDate={firstDayOfMonth}
                      label="Month to"
                      value={dateTo}
                      views={['year', 'month']}
                      onChange={handleChangeDateTo}
                    />
                  </div>
                </>
              )
            }
            <div className="item w(|min)250 mr10">
              <ButtonBlack
                className="hmin56 mt20"
                onClick={handleLoading}
                target="_blank"
                href={getLink('csv')}
                download={getName('csv')}
                disabled={!isCurrentMonth && disableBtns}
              >Download report CSV</ButtonBlack>
            </div>
            <div className="item w(|min)250">
              <ButtonBlack
                className="hmin56 mt20"
                onClick={handleLoading}
                target="_blank"
                href={getLink('pdf')}
                download={getName('pdf')}
                disabled={!isCurrentMonth && disableBtns}
              >Download report PDF</ButtonBlack>
            </div>
          </div>
        </WrapperWithLoading>
      </LayoutA>
    )
  }
})
